import React from "react";
import { Route, Routes } from "react-router-dom";
import MathuraInfrastructure from "./mathuraInfrastructure";

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<MathuraInfrastructure />} />
      </Routes>
    </>
  );
};

export default App;
